<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-package'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="totalWorkOrdersPercentageChange"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [isImageIcon]="false"
  [dropdownEnabled]="false"
  [hasFooter]="false"
  [hasValueOnly]="true"
  [hasDifference]="false"
  [isUptrendPositive]="false"
  [widgetDisabled]="true"
  (clicked)="openBreakdownModal()"></app-kpi-widget>